module.exports = {
    admin: 'Admin',
    parent: 'Parent',
    centerAdmin: 'CenterAdmin',
    centerDirector: 'CenterDirector',
    teacher: 'Teacher'
}